import { render } from "./AttributeSelector.vue?vue&type=template&id=6285fc52&scoped=true"
import script from "./AttributeSelector.vue?vue&type=script&lang=js"
export * from "./AttributeSelector.vue?vue&type=script&lang=js"

import "./AttributeSelector.vue?vue&type=style&index=0&id=6285fc52&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6285fc52"]])

export default __exports__
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QTable from 'quasar/src/components/table/QTable.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCardSection,QTable});qInstall(script, 'directives', {ClosePopup});
